module.exports = __webpack_public_path__ + "new-5455795b/template-3-2x-b7462c37c2aededcfbeeba676ff1d246.jpg";